import { platforms } from "@/mocks/watchGuide";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function Platforms() {
  return (
    <section id="platforms" className="w-full bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <SectionHeading
          eyebrow="观看平台 · 正版优先"
          title="带中文字幕的日韩内容，主要在哪些平台"
          desc="不同平台的片库与字幕策略差别很大。下表按地区与字幕特点做了梳理，方便你按自己常用的平台对号入座。具体上线信息会随版权变化，请以平台实时页面为准。"
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {platforms.map((p) => (
            <article
              key={p.id}
              className="flex flex-col rounded-lg bg-background-100 border border-background-200/70 p-4 md:p-5 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="w-11 h-11 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center">
                  <i className={`${p.icon} text-2xl`}></i>
                </span>
                <span className="text-[11px] md:text-xs text-foreground-500 hidden sm:block">
                  {p.region}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                {p.name}
              </h3>
              <p className="mt-1 text-xs font-medium text-accent-700 flex items-center gap-1">
                <i className="ri-check-line"></i>
                {p.highlight}
              </p>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed flex-1">{p.desc}</p>
              <div className="mt-4 flex flex-wrap gap-1.5">
                {p.tags.map((t) => (
                  <span
                    key={t}
                    className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px]"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 flex items-start gap-3 rounded-lg bg-accent-50 border border-accent-200/70 p-4 md:p-5">
          <span className="w-9 h-9 rounded-md bg-accent-500 text-background-50 flex items-center justify-center shrink-0">
            <i className="ri-information-line text-xl"></i>
          </span>
          <p className="text-sm text-foreground-700 leading-relaxed">
            <strong className="text-foreground-950">提示：</strong>
            影视版权按地区分别授权，同一平台在不同国家 / 地区的片库与字幕轨可能不同。若某部作品提示无法播放，多为正常的区域限制，建议在对应地区的正版渠道观看。
          </p>
        </div>
      </div>
    </section>
  );
}